import { reactQueryGet } from "@/react/helpers/backendRequestHelpers";
import { recommendations } from "@/react/helpers/urlHelpers/internalApi/recommendations";
import type { CommunityMember } from "@/react/types";

interface Recommendation {
  target_community_member: CommunityMember;
}

type GetRecommendationsResponse = Recommendation[];

export const recommendationsApi = {
  getRecommendations: () =>
    reactQueryGet<GetRecommendationsResponse>(recommendations.index()),
};
